import { AbstractNavTreeService, RoutesService, NAVIGATE_TO_MANAGE_PROFILE } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { NAVIGATE_TO_MY_SECURITY_LOGS } from '@volo/abp.commercial.ng.ui/config';
import { Router } from '@angular/router';

class ManageProfileTabsService extends AbstractNavTreeService {
}
ManageProfileTabsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: ManageProfileTabsService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ManageProfileTabsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: ManageProfileTabsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: ManageProfileTabsService, decorators: [{
            type: Injectable
        }] });

const ACCOUNT_MANAGE_PROFILE_TAB_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: configureTabs,
        deps: [ManageProfileTabsService],
        multi: true,
    },
];
function configureTabs(tabs) {
    return () => {
        tabs.add([
            {
                name: "AbpAccount::ProfileTab:Picture" /* eAccountManageProfileTabNames.ProfilePicture */,
                order: 1,
                component: null,
            },
            {
                name: "AbpAccount::ProfileTab:Password" /* eAccountManageProfileTabNames.ChangePassword */,
                order: 2,
                component: null,
            },
            {
                name: "AbpAccount::ProfileTab:PersonalInfo" /* eAccountManageProfileTabNames.PersonalInfo */,
                order: 3,
                component: null,
            },
            {
                name: "AbpAccount::ProfileTab:TwoFactor" /* eAccountManageProfileTabNames.TwoFactor */,
                order: 4,
                component: null,
            },
        ]);
    };
}

const ACCOUNT_ROUTE_PROVIDERS = [
    { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];
function configureRoutes(routes) {
    return () => {
        routes.add([
            {
                path: '/account',
                name: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
                invisible: true,
                layout: "account" /* eLayoutType.account */,
            },
            {
                path: '/account/login',
                name: "AbpAccount::Login" /* eAccountRouteNames.Login */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
            },
            {
                path: '/account/register',
                name: "AbpAccount::Register" /* eAccountRouteNames.Register */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
            },
            {
                path: '/account/forgot-password',
                name: "AbpAccount::ForgotPassword" /* eAccountRouteNames.ForgotPassword */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
            },
            {
                path: '/account/reset-password',
                name: "AbpAccount::ResetPassword" /* eAccountRouteNames.ResetPassword */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
            },
            {
                path: '/account/email-confirmation',
                name: "AbpAccount::EmailConfirmation" /* eAccountRouteNames.EmailConfirmation */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
            },
            {
                path: '/account/link-logged',
                name: "AbpAccount::LinkLogged" /* eAccountRouteNames.LinkLogged */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
            },
            {
                path: '/account/send-security-code',
                name: "AbpAccount::TwoFactorVerification" /* eAccountRouteNames.SendSecurityCode */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
            },
            {
                path: '/account/manage',
                name: "AbpAccount::MyAccount" /* eAccountRouteNames.ManageProfile */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
                layout: "application" /* eLayoutType.application */,
            },
            {
                path: '/account/security-logs',
                name: "AbpAccount::MySecurityLogs" /* eAccountRouteNames.MySecurityLogs */,
                parentName: "AbpAccount::Menu:Account" /* eAccountRouteNames.Account */,
                layout: "application" /* eLayoutType.application */,
            },
        ]);
    };
}

function navigateToManageProfileFactory(injector) {
    return () => {
        const router = injector.get(Router);
        const routes = injector.get(RoutesService);
        const { path } = routes.find(item => item.name === "AbpAccount::MyAccount" /* eAccountRouteNames.ManageProfile */);
        router.navigateByUrl(path);
    };
}
function navigateToMySecurityLogsFactory(injector) {
    return () => {
        const router = injector.get(Router);
        const routes = injector.get(RoutesService);
        const { path } = routes.find(item => item.name === "AbpAccount::MySecurityLogs" /* eAccountRouteNames.MySecurityLogs */);
        router.navigateByUrl(path);
    };
}

class AccountPublicConfigModule {
    static forRoot() {
        return {
            ngModule: AccountPublicConfigModule,
            providers: [
                ACCOUNT_ROUTE_PROVIDERS,
                ManageProfileTabsService,
                ACCOUNT_MANAGE_PROFILE_TAB_PROVIDERS,
                {
                    provide: NAVIGATE_TO_MANAGE_PROFILE,
                    useFactory: navigateToManageProfileFactory,
                    deps: [Injector],
                },
                {
                    provide: NAVIGATE_TO_MY_SECURITY_LOGS,
                    useFactory: navigateToMySecurityLogsFactory,
                    deps: [Injector],
                },
            ],
        };
    }
}
AccountPublicConfigModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AccountPublicConfigModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AccountPublicConfigModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.2", ngImport: i0, type: AccountPublicConfigModule, imports: [CommonModule] });
AccountPublicConfigModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AccountPublicConfigModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AccountPublicConfigModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [],
                    declarations: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ACCOUNT_MANAGE_PROFILE_TAB_PROVIDERS, ACCOUNT_ROUTE_PROVIDERS, AccountPublicConfigModule, ManageProfileTabsService, configureRoutes, configureTabs };
